import React from 'react';
import { BlogPagination } from '../BlogPagination';

var Articles = function Articles(_ref) {
  var next = _ref.next,
      previous = _ref.previous,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "blog-articles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, children), /*#__PURE__*/React.createElement(BlogPagination, {
    next: next,
    previous: previous
  }));
};

Articles.displayName = 'Articles';
var ArticlesDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  ArticlesDoc = require('./doc').doc(Articles);
}

var ArticlesWrapper = ArticlesDoc || Articles;
export { ArticlesWrapper as Articles };